import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { AppConfig } from "../Utilities/app-config.service";
import { ApiService } from "./api.service";
import * as signalR from "@aspnet/signalr";
import { environment as env } from "@env/environment";
import { ChatEmitterService } from "./chat-emitter.service";
import axios from "axios";
import { ResultStatus } from "../models/result-status";
import { AuthenticationService } from './authentication.service';
import { HttpClient } from '@angular/common/http';

const SR_BASE_URL = env.signalRBaseUrl;
const BASE_URL = env.serverUrl;

@Injectable({
  providedIn: "root",
})
export class ChatService {
  public userActiveChatDetails: Subject<any> = new Subject<any>();
  constructor(
    private apiService: ApiService,
    private appConfig: AppConfig,
    public _httpClient: HttpClient
  ) { }

  SharedChatComponent: ISharedChatModel = {
    userActiveChat: [],
    newMessageFound: false,
    userArchiveChat: []
  };

  public userDetailsObs = this.userActiveChatDetails.asObservable();

  getActiveUsersChat() {
    this.getActiveUsers().subscribe((response) => {
      if (response.Status === ResultStatus.Success) {
        this.SharedChatComponent.userActiveChat = response.Data;
      }
    });
  }

  setuserArchiveChat() {
    this.getuserArchiveChat().subscribe((response) => {
      if (response.Status === ResultStatus.Success) {
        this.SharedChatComponent.userArchiveChat = response.Data;
      }
    });
  }

  getActiveUsers() {
    return this.apiService.get(this.appConfig.GetUrl("getActiveChat"));
  }

  getuserArchiveChat() {
    return this.apiService.get(this.appConfig.GetUrl("getArchiveChat"));
  }

  getActiveUsersChatStatus() {
    return this.apiService.get(this.appConfig.GetUrl("getChatStatus"));
  }

  getUsersChatId(id: number, pageNo: number, senderId, receiverId) {
    return this.apiService.get(
      this.appConfig.GetUrl("getChatById").replace("[CHATID]", id) +
      `?pageNo=${pageNo}&senderId=${senderId}&receiverId=${receiverId}`
    );
  }

  updateChat(postData: any): Observable<any> {
    return this._httpClient.put(BASE_URL + this.appConfig.GetUrl("updateChat"), postData);
  }

  readMessage(id) {
    return this.apiService.put(
      this.appConfig.GetUrl("readMessage").replace("[CHATID]", id)
    );
  }

  archiveChat(id) {
    return this.apiService.delete(
      this.appConfig.GetUrl("deleteChat").replace("[CHATID]", id)
    );
  }
}
export interface ISharedChatModel {
  userActiveChat: [];
  newMessageFound: boolean;
  userArchiveChat: any[];
}

@Injectable({
  providedIn: "root",
})
export class SignalRService {
  public data: [];
  connnectionTimeOut: any;
  startTimeOut: any;

  constructor(
    private authService: AuthenticationService,
    private chatEmitterService: ChatEmitterService,
    private chatService: ChatService
  ) { }

  private hubConnection: signalR.HubConnection;

  public startConnection = (userId) => {
    if (!this.hubConnection || this.hubConnection.state !== signalR.HubConnectionState.Connected) {
      this.getConnectionInfo(userId).then((info) => {
        const options = {
          accessTokenFactory: () => info.accessToken,
        };

        this.hubConnection = new signalR.HubConnectionBuilder()
          .withUrl(info.url, options)
          .configureLogging(signalR.LogLevel.Information)
          .configureLogging(signalR.LogLevel.Error)
          .build();

        this.hubConnection
          .start()
          .then()
          .catch((err) => {
            console.log("Error while starting connection: " + err);
            if (this.hubConnection.state === signalR.HubConnectionState.Disconnected &&
              this.authService.isUserLoggedIn()) {
              this.startTimeOut = setTimeout(() => {
                this.startConnection(+this.authService.getUserInformation()["ID"]);
              }, 5000);
            }
          });

        this.activeDefaultListener();
      });
    }
  }

  public stopConnection = () => {
    if (this.hubConnection) {
      this.hubConnection
        .stop()
        .then(() => { clearTimeout(this.connnectionTimeOut); clearTimeout(this.startTimeOut); })
        .catch((err) => console.log("Error while stopping connection: " + err));
    }
  }

  public getConnectionInfo(userId: string) {
    return axios
      .post(`${SR_BASE_URL}/negotiate`, null, this.getAxiosConfig(userId))
      .then((resp) => resp.data, (errors) => { console.log("Error") });
  }

  public getAxiosConfig(userId: string) {
    const config = {
      headers: { "x-ms-signalr-userid": userId },
    };
    return config;
  }

  public activeDefaultListener = () => {
    this.connnectionTimeOut = setTimeout(() => {
      if (this.hubConnection.state === signalR.HubConnectionState.Disconnected &&
        this.authService.isUserLoggedIn()) {
        this.startConnection(+this.authService.getUserInformation()["ID"]);
      }
    }, 600000);

    this.hubConnection.on("newChatMessage", (data) => {
      const senderID = +this.authService.getUserInformation()["ID"];
      if (+senderID === +data.UserId) {
        this.chatService.SharedChatComponent.newMessageFound = true;
      }
      this.chatService.getActiveUsersChat();
      this.chatEmitterService.newIncomingMessage(data);
    });

    this.hubConnection.on("sendChatMessage", (data) => {
      this.chatService.getActiveUsersChat();
      this.chatEmitterService.newIncomingMessage(data);
    });

    this.hubConnection.on("newMessage", (data) => {
      this.chatEmitterService.updateInboxCount();
    });

    this.hubConnection.on("newNotification", (data) => {
      this.chatEmitterService.updateNotificationCount();
    });
  }
}
